import {COLOR_ACTIVE, COLOR_DISABLED, GeographyProps, HOVER_COLOR,} from "../types";
import {CARICOM_STATES, Country, LATAM_COUNTRY_NAMES,} from "../../../../../features/countries/types";
import {hoverTooltip} from "../hoverTooltip";
import {Geography} from "react-simple-maps";
import theme from "../../../../../components/styles/theme/theme";
import React from "react";

const renderGeographyForLATAM = (
    geo: GeographyProps,
    countries: Country[],
    handleCountrySelect: (geography: any) => () => void,
    year: string,
    selectedCountry?: Country,
) => {
    const {rsmKey, properties} = geo;

    const caricomCountry = countries.find(el => el.country_name.toUpperCase() === LATAM_COUNTRY_NAMES.CARICOM.toUpperCase());

    const isCaricom = caricomCountry?.states.find(
        (country) => country.iso3 === properties.iso3
    );

    const availableCountry = countries.find(
        (country) => country.iso3 === properties.iso3
    );
    const availableCountryInsideCaricom =
        caricomCountry &&
        caricomCountry.states.find((country) => country.iso3 === properties.iso3);
    const availableCountryAll = availableCountry || availableCountryInsideCaricom;

    const setColorForActiveCountry = (color: string) =>
        availableCountryAll ? color : COLOR_DISABLED;

    const key = `${rsmKey}-${properties.iso3}`;

    let dataTooltipHtml = null;

    //The CARICOM map still shows 2021 data when hovering over the countries.
    // Please still implement this update.
    // Only the following countries should have a pop-up this year:
    // Bahamas,
    // Haiti,
    // Trinidad and Tobago,
    // Suriname,
    // Belize.
    //
    // The values for the pop-up boxes are added in the tab ‘textbox_caricom’ in the Excel attached to this email.
    // The other countries that are shown on the map should not have a pop-up

    const customCaricomState = (facilities_value: string, direct_jobs_value: string, indirect_jobs_value: string, gdp_contribution_value: string) => ({
        facilities_value,
        direct_jobs_value,
        indirect_jobs_value,
        gdp_contribution_value
    })

    if ((!selectedCountry || selectedCountry.country_name === LATAM_COUNTRY_NAMES.LATAM) && availableCountry) {
        dataTooltipHtml = hoverTooltip(availableCountry, properties.name, true);
    } else if (isCaricom && caricomCountry) {
        if (year === '2021') {
            dataTooltipHtml = hoverTooltip(
                caricomCountry,
                `${LATAM_COUNTRY_NAMES.CARICOM} - (${properties.name})`
            );
        } else {
            let country = null;
            switch (properties.name.toUpperCase()) {
                case CARICOM_STATES.BAHAMAS.toUpperCase():
                    country = customCaricomState('0', '243', '3600', '1,8%');
                    break;
                case CARICOM_STATES.HAITI.toUpperCase():
                    country = customCaricomState('0','802', '5100', '0,7%');
                    break;
                case CARICOM_STATES.TRINIDAD_AND_TOBAGO.toUpperCase():
                    country = customCaricomState('0','479', '2700', '0,8%');
                    break;
                case CARICOM_STATES.SURINAME.toUpperCase():
                    country = customCaricomState('0','365', '2600', '1,2%');
                    break;
                case CARICOM_STATES.BELIZE.toUpperCase():
                    country = customCaricomState('0','1012', '2400', '2,2%');
                    break;
            }
            if (country) {
                dataTooltipHtml = hoverTooltip(
                    country,
                    `${properties.name} - (${LATAM_COUNTRY_NAMES.CARICOM})`
                );
            }

        }
    }


    return (
        // @ts-ignore
        <Geography
            key={key}
            stroke={theme.palette.common.white}
            strokeWidth={0.2}
            geography={geo}
            className={`${selectedCountry ? properties.name : ""}${
                isCaricom ? ` ${LATAM_COUNTRY_NAMES.CARICOM}` : ""
            }`}
            data-tooltip-html={dataTooltipHtml}
            data-tooltip-id="my-tooltip"
            data-tooltip-offset={10}
            data-tooltip-place="right"
            style={{
                default: {
                    fill: setColorForActiveCountry(COLOR_ACTIVE),
                    outline: "none",
                },
                hover: {
                    fill: setColorForActiveCountry(
                        selectedCountry ? COLOR_ACTIVE : HOVER_COLOR
                    ),
                    outline: "none",
                    cursor: availableCountryAll ? "pointer" : "",
                },
                pressed: {
                    fill: setColorForActiveCountry(COLOR_ACTIVE),
                    outline: "none",
                },
            }}
            onMouseOver={() => {
                const caricomCountries = document.querySelectorAll(
                    `.${LATAM_COUNTRY_NAMES.CARICOM}`
                );
                !selectedCountry &&
                isCaricom &&
                caricomCountries.forEach((country) => {
                    const element = country as HTMLElement;
                    element.style.fill = HOVER_COLOR;
                });
            }}
            onMouseOut={() => {
                const caricomCountries = document.querySelectorAll(
                    `.${LATAM_COUNTRY_NAMES.CARICOM}`
                );
                !selectedCountry &&
                isCaricom &&
                caricomCountries.forEach((country) => {
                    const element = country as HTMLElement;
                    element.style.fill = COLOR_ACTIVE;
                });
            }}
            onClick={handleCountrySelect(geo)}
        />
    );
};
export default renderGeographyForLATAM;
